import React from 'react';

const DepositFundsLoading = () => {
  return (
    <div role="status" aria-live="polite">
      <div className="row">
        <div className="col col-md-12">&nbsp;</div>
      </div>
      <div className="row">
        <div className="col col-md-12">&nbsp;</div>
      </div>
      <div className="row">
        <div className="col col-md-12 text-center">
          <img src="images/1488.gif" alt="spinner" />
          <span className="sr-only">Taking you to funding&hellip;</span>
        </div>
      </div>
      <div className="row">
        <div className="col col-md-12">&nbsp;</div>
      </div>
      <div className="row">
        <div className="col col-md-12">&nbsp;</div>
      </div>
    </div>
  );
};

export default DepositFundsLoading;
